import { VariableBenefitRecurringPaymentRow } from './variable-benefit-recurring-payment-row';
import { StatusPill } from '../../../../../models/shared/status-pill';

export enum VbRecurringPaymentInstructionType {
  Active,
  Scheduled
}

export interface VbRecurringPaymentInstructionCard {
  instructionType: VbRecurringPaymentInstructionType;
  isMonthly: boolean;
  rows: VariableBenefitRecurringPaymentRow[];
  total: number;
  annualTotal: number;
  statusPill: StatusPill;
  subtext?: string;
}
